import { memo, type ReactNode } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { WaTemplateSetup } from "features/waMessaging/types";

type Props = {
    readonly resource: WaTemplateSetup;
};

const Row = ({
    label,
    children,
    multiline
}: {
    readonly label: string;
    readonly children: ReactNode;
    readonly multiline?: boolean;
}) => (
    <Box
        sx={{
            display: 'grid',
            gridTemplateColumns: '200px 1fr',
            alignItems: 'baseline',
            gap: 2,
            py: 1,
            borderBottom: '1px solid',
            borderColor: 'divider'
        }}
    >
        <Typography variant='body2' color='text.secondary'>
            {label}
        </Typography>
        <Typography
            variant='body2'
            sx={multiline ? { whiteSpace: 'pre-wrap', wordBreak: 'break-word' } : undefined}
        >
            {children ?? '—'}
        </Typography>
    </Box>
);

const WaTemplateSetupView = ({ resource }: Props) => (
    <Stack spacing={0}>
        <Row label='Domain'>{resource.MOR}</Row>
        <Row label='Template' multiline>{resource.messageTemplate}</Row>
        <Row label='Date Created'>{resource.createdAt}</Row>
        <Row label='Date Updated'>{resource.updatedAt}</Row>
    </Stack>
);

export default memo(WaTemplateSetupView);
